import React from 'react';
import { Route } from 'react-router';

import * as crudTypes from './CrudTypes.js';

const hasPermission = (
  { config, userAccess },
  standaloneSeletor,
  keycloakSeletor,
  type
) => {
  if (config.isCloud) {
    return userAccess[keycloakSeletor];
  }

  const permission = userAccess[standaloneSeletor];
  if (permission) {
    return getPermissionByType(type, permission);
  }
};

const getPermissionByType = (type, permission) => {
  if (crudTypes.CRUD_TYPE_READ) {
    return !!permission;
  }

  if (type === crudTypes.CRUD_TYPE_NEW) {
    return permission.inserir;
  }

  if (type === crudTypes.CRUD_TYPE_UPDATE) {
    return permission.alterar;
  }

  if (type === crudTypes.CRUD_TYPE_DELETE) {
    return permission.excluir;
  }
};

export const ProtectedRoute = (
  params,
  standaloneSeletor,
  keycloakSeletor,
  route,
  component,
  type
) => {
  const permission = hasPermission(
    params,
    standaloneSeletor,
    keycloakSeletor,
    type
  );
  if (permission) {
    return <Route exact path={route} component={component} />;
  }

  return null;
};
